import React from "react";
import ReactDOM from "react-dom";
import "mdbreact/dist/css/mdb.css";
import "mdb-react-ui-kit/dist/css/mdb.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "react-toastify/dist/ReactToastify.css";

import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";

import { ToastContainer } from "react-toastify";

ReactDOM.render(
  <Router>
    <ToastContainer />
    <App />
  </Router>,
  document.getElementById("root")
);
